import { Dropdown } from 'react-bootstrap';
import { CountryCode } from '../../../../models/Currency';

interface CountryFilterProps {
  country: string;
  onCountryChange: (value: string) => void;
  // PIC search queries the PIC GSI, which can't filter by country, so the country
  // filter is disabled while a PIC search is selected (pic+countryCode is a 400).
  disabled?: boolean;
}

export function CountryFilter({ country, onCountryChange, disabled = false }: CountryFilterProps) {
  const countries = ['Select Country', ...Object.values(CountryCode)];

  return (
    <div className="flex items-center gap-2">
      <Dropdown className="w-full">
        <Dropdown.Toggle
          variant="outline-dark"
          className="cursor-pointer"
          disabled={disabled}
          title={disabled ? 'PIC search covers all countries' : undefined}
          style={{
            width: '140px',
            color: country && country !== 'Select Country' ? '#EE6767' : undefined,
          }}
        >
          {country || 'Country'}
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-2 max-h-96 overflow-y-auto" style={{ width: '160px' }}>
          {countries.map((c) => (
            <Dropdown.Item
              className="cursor-pointer"
              key={c}
              onClick={() => onCountryChange(c)}
              active={c === country}
              style={c === country && c !== 'Select Country' ? { color: '#EE6767' } : {}}
            >
              {c}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
